import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "@appkit4/react-components/header";
import { Avatar } from "@appkit4/react-components/avatar";
import { DropdownButton } from "@appkit4/react-components/dropdown";
import { bindSentryUser } from "../../../config/sentry";
import StorageService from "../../../services/StorageService";

type ValueType = string | number;
type ItemDataType = {
  value?: ValueType;
  label?: string;
  disabled?: boolean;
  iconName?: string;
  [key: string]: any;
};

// ← safe, no external deps, won’t throw
const emailToDisplayName = (email: string): string => {
  try {
    const local = email.split("@")[0] || email;
    const parts = local.split(/[._-]+/).filter(Boolean);
    if (!parts.length) return email;
    return parts.map(p => p.charAt(0).toUpperCase() + p.slice(1)).join(" ");
  } catch {
    return "User";
  }
};

const initialsFromEmail = (email: string): string => {
  try {
    const local = email.split("@")[0] || email;
    const parts = local.split(/[._-]+/).filter(Boolean);
    const a = parts[0]?.[0] ?? "";
    const b = parts[1]?.[0] ?? "";
    return (a + b).toUpperCase() || "U";
  } catch {
    return "U";
  }
};

const HeaderSample = () => {
  const [initials, setInitials] = useState("U");
  const navigate = useNavigate();

  useEffect(() => {
    const userEmail = localStorage.getItem("userEmail") || "";
    if (userEmail) {
      setInitials(initialsFromEmail(userEmail));
      // Bind Sentry user here
      bindSentryUser({
        id: userEmail,                 
        email: userEmail,              
        username: emailToDisplayName(userEmail),
      });
    } else {
      bindSentryUser(null);
    }
  }, []);

  const handleLogout = () => {
    bindSentryUser(null);             // clear Sentry user on logout
    StorageService.clearAll();
    navigate("/login");
  };

  const handleDropdownSelect = (value: ValueType) => {
    if (value === "logout") handleLogout();
  };

  const dropdownItems: ItemDataType[] = [
    { value: "logout", label: "Logout", iconName: "lockclosed-locked-outline" },
  ];

  return (
    <div className="header-demo-wrapper">
      <Header
        type="transparent"
        onClickLogo={() => {}}
        titleTemplate={() => ""}
        subTitleTemplate={() => "Document Operations Toolbox"}
        userTemplate={() => (
          <DropdownButton
            customTriggerNode
            customTriggerClassName="custom-node"
            data={dropdownItems}
            onSelect={handleDropdownSelect}
            align="right"
            prefixTemplate={(item: ItemDataType) => (
              <span className={`Appkit4-icon icon-${item.iconName}`} />
            )}
          >
            <Avatar label={initials} role="button" disabled={false} ariaLabel="User menu" />
          </DropdownButton>
        )}
      />
    </div>
  );
};

export default HeaderSample;
